export default __webpack_public_path__ + "static/media/interior.89894483.webp";